import {Module} from "vuex";
import {RootState} from "@/store/types";
import {TemplateParamsState} from "@/store/settings/template_params/types";
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: TemplateParamsState = {
  templateParams: []
}

export const templateParams: Module<TemplateParamsState, RootState> = {
  state,
  getters,
  actions,
  mutations
}